import { Component, Input, OnInit, SimpleChanges, OnChanges, Output, EventEmitter } from '@angular/core';
import { NzFormatEmitEvent } from 'ng-zorro-antd/tree';
import { CommonService } from '../../service/common/common.service';

@Component({
  selector: 'structure',
  templateUrl: './structure.component.html',
  styleUrls: ['./structure.component.less'],
})
export class StructureComponent implements OnInit, OnChanges {
  /**
   * 数据源
   */
  @Input() data: Array<object> = [];
  /**
   * 检索员工类型 1在职2离职3黑名单
   */
  @Input() searchType: number = 1;
  /**
   * 整体高度
   */
  @Input() height: number = 600;
  /**
   * 类型选项
   */
  typeOptions: Array<object> = [];
  /**
   * 选择的机构类型
   */
  checkType: number = 1;
  structure: Array<object> = [];
  showStructure: Array<object> = [];
  @Input() checkData = [];
  @Output() checkDataChange = new EventEmitter();
  @Input() checkOrgan = 1; // 选中公司类型id
  @Output() checkOrganChange = new EventEmitter(); // 回调选择公司类型事件
  selectIds: Array<any> = [];
  searchKey: string = '';
  searchStatus: boolean = false;
  searchEmployeeData: Array<object> = [];
  foldIndex: Array<number> = [];
  checkEmployeeID: number = 0;
  defaultExpandedKeys: Array<any> = [];

  constructor(private common: CommonService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] != undefined) {
      this.dealTab();
      this.structure = [...this.dealStructure(this.data)];
      if (this.structure.length != 0) {
        let tabIndex = 0;
        this.structure.map((item, i) => {
          // console.log(item, i);
          if (item['key'] == this.checkOrgan) {
            tabIndex = i;
          }
        });
        // console.log('checkOrgan', this.checkOrgan, 'tabIndex', tabIndex);

        this.checkType = this.checkOrgan;
        this.showStructure = [...this.structure[tabIndex]['children']];
        setTimeout(() => {
          // console.log('typeOptions', this.typeOptions[tabIndex]['value']);
          this.checkTypeChange(this.typeOptions[tabIndex]['value']);
        }, 0);
      }
    }
  }

  /**
   * 处理组织架构
   */
  dealStructure(data: Array<object>): any {
    const response: Array<object> = [];
    for (const structure of data) {
      const item = {};
      item['title'] = structure['organ_name'];
      item['key'] = structure['organ_id'];
      item['value'] = structure['organ_id'];
      item['parent'] = structure['organ_pid'];
      item['status'] = structure['status'];
      Object.assign(item, structure);
      delete item['child_node'];
      if (structure['child_node'].length > 0) {
        item['children'] = this.dealStructure(structure['child_node']);
      } else {
        item['isLeaf'] = true;
      }
      response.push(item);
    }
    return response;
  }

  /**
   * 处理类型tab数据
   */
  dealTab(): void {
    const typeOptions = [];
    // 遍历数据 将数据第一层取出来作为tab数据源
    for (const i of this.data) {
      if (i['child_node'].length == 0) {
        continue;
      }
      const item = {
        title: i['organ_name'],
        value: i['organ_id'],
      };
      typeOptions.push(item);
    }
    this.typeOptions = [...typeOptions];
  }

  /**
   * 选择组织架构类型
   * @param $event
   */
  checkTypeChange($event: number): void {
    // console.log('checkTypeChange', $event);
    let index = 0;
    this.structure.map((item, i) => {
      if (item['key'] == $event) {
        index = i;
      }
    });
    if (this.structure[index]['children'] == undefined) {
      this.checkData = [...[]];
      this.selectIds = [...[]];
      this.showStructure = [...[]];
      this.checkDataChange.emit({ event: 'check', target: [{}], type: 'organ' });
      return;
    }
    this.checkOrganChange.emit({ event: 'check', target: [{ id: $event }], type: 'organ' });
    const showStructure = [...this.structure[index]['children']];
    this.showStructure = JSON.parse(JSON.stringify(showStructure));
    // console.log('checkData', this.checkData);
    const defaultCheckData =
      this.checkData.length > 0 ? { ...this.checkData[0] } : showStructure[0] != undefined ? { ...showStructure[0] } : false;
    const checkData = [];
    const selectIds = [];
    // 判断是否存在默认选中数据
    // console.log('defaultCheckData', defaultCheckData);
    if (!defaultCheckData) {
    } else {
      checkData.push({
        key: defaultCheckData['key'],
        title: defaultCheckData['title'],
        manage_name: defaultCheckData['manage_name'],
        organ_peoples: defaultCheckData['organ_peoples'],
      });
      selectIds.push(defaultCheckData['key']);
    }
    //  设置默认展开数据
    const defaultExpandedKeys = [];
    showStructure.map((item) => {
      defaultExpandedKeys.push(item['key']);
    });

    this.defaultExpandedKeys = [...defaultExpandedKeys];
    this.checkData = [...checkData];
    this.selectIds = [...selectIds];

    for (const i of this.showStructure) {
      i['arr'] = [];
      if (i['children']) {
        this.expandedFn(i['children'], i['arr']);
      }
    }
    this.checkDataChange.emit({ event: 'check', target: checkData, type: 'organ' });
  }

  // 展开数据
  expandedFn(data: any, arr: any): void {
    for (const i of data) {
      i.arr = [...arr];
      if (i.key == this.checkData[0].key) {
        this.defaultExpandedKeys = this.defaultExpandedKeys.concat(arr);
        // console.log(this.defaultExpandedKeys);
      } else {
        i.arr.push(i.key);
        if (i.children != undefined) {
          this.expandedFn(i.children, i.arr);
        }
      }
    }
  }

  /**
   * 选择组织架构
   * @param $event
   */
  checkStructure($event: NzFormatEmitEvent): void {
    // console.log('checkStructure', $event.node);
    const checkData = [$event.node.origin];
    this.checkData = [...checkData];
    const selectIds = [];
    checkData.map((item) => {
      selectIds.push(item['key']);
    });
    this.selectIds = [...selectIds];
    this.checkDataChange.emit({ event: 'check', target: checkData, type: 'organ', isSearch: this.searchKey != '' });
  }

  /**
   * 检索组织架构和人员
   * @param event
   */
  search(): void {
    if (this.searchKey == '') {
      this.checkEmployeeID = 0;
      this.searchStatus = false;
    } else {
      this.searchStatus = true;
      this.getEmployee().then((res) => {
        this.searchEmployeeData = [...res];
      });
    }
  }

  /**
   * 同步检索符合条件的员工
   */
  async getEmployee(): Promise<any> {
    return new Promise((resolve) => {
      this.common.ajax({
        url: 'employee/getEmployeeTree',
        data: { username: this.searchKey, search_type: this.searchType },
        loading: true,
        success: (res) => {
          resolve(res);
        },
      });
    });
  }

  /**
   * 选择检索出的员工
   * @param $event
   */
  checkEmployee($event: any): void {
    this.checkEmployeeID = $event.employee_id;
    this.checkDataChange.emit({ event: 'check', target: [$event], type: 'employee', isSearch: this.searchKey != '' });
  }

  /**
   * 点击人员折叠或者展开
   * @param index
   */
  clickFold(index: number): void {
    const foldIndex = [...this.foldIndex];
    if (foldIndex.indexOf(index) > -1) {
      foldIndex.splice(foldIndex.indexOf(index), 1);
    } else {
      foldIndex.push(index);
    }
    this.foldIndex = [...foldIndex];
  }

  /**
   * 检索关键字清空
   */
  clearSearch(): void {
    this.searchKey = '';
    this.searchStatus = false;
  }
}
